 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"channelStoriesPage-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage":"channelStoriesPage-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage","channelStoriesPage":"channelStoriesPage","mobile403":"mobile403","mobileChangePasswordPage":"mobileChangePasswordPage","mobileExploreCategoryPage":"mobileExploreCategoryPage","mobileExploreResultsPage-mobileSearchResultsPage":"mobileExploreResultsPage-mobileSearchResultsPage","mobileExploreResultsPage":"mobileExploreResultsPage","mobileSearchResultsPage":"mobileSearchResultsPage","mobileFavoritesPage":"mobileFavoritesPage","mobileResetPasswordPage":"mobileResetPasswordPage","mobileTrendingPage":"mobileTrendingPage","vendors-gifEditPanel-gifMakerFinalize":"vendors-gifEditPanel-gifMakerFinalize","vendors-gifEditPanel":"vendors-gifEditPanel","gifEditPanel":"gifEditPanel","vendors-gifMakerFinalize-mobile404-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPa-9467c26e":"vendors-gifMakerFinalize-mobile404-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPa-9467c26e","gifMakerFinalize-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage":"gifMakerFinalize-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage","mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage":"mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage","mobileChannelBranchPage":"mobileChannelBranchPage","mobileChannelLeafPage":"mobileChannelLeafPage","mobileChannelListPage":"mobileChannelListPage","mobileChannelPage":"mobileChannelPage","mobile404":"mobile404","mobileApplyPage-mobileJoinPage-mobileLoginPage":"mobileApplyPage-mobileJoinPage-mobileLoginPage","mobileJoinPage-mobileLoginPage":"mobileJoinPage-mobileLoginPage","mobileJoinPage":"mobileJoinPage","mobileLoginPage":"mobileLoginPage","vendors-gifMakerFinalize-mobileGifMaker":"vendors-gifMakerFinalize-mobileGifMaker","vendors-mobileApplyPage-mobileGifMaker":"vendors-mobileApplyPage-mobileGifMaker","vendors-mobileGifMaker":"vendors-mobileGifMaker","mobileGifMaker":"mobileGifMaker","mobileApplyPage":"mobileApplyPage","vendors-mobileDashboard":"vendors-mobileDashboard","mobileDashboard":"mobileDashboard","vendors-mobileTeamPage":"vendors-mobileTeamPage","mobileTeamPage":"mobileTeamPage","vendors-showdown":"vendors-showdown","gifDetailMedia":"gifDetailMedia","creationAnimate":"creationAnimate","creationCutOut":"creationCutOut","desktopUploadFinalize":"desktopUploadFinalize","gifMakerSlideshow":"gifMakerSlideshow","gifMakerVideoTrim":"gifMakerVideoTrim","gifMakerFinalize":"gifMakerFinalize","aboutPage":"aboutPage","appsLanding":"appsLanding","artists":"artists","curationStation":"curationStation","desktopChannelStories":"desktopChannelStories","desktopStory":"desktopStory","desktopVideoDetail":"desktopVideoDetail","desktopVideos":"desktopVideos","homebase":"homebase","homepageBeta":"homepageBeta"}[chunkId]||chunkId) + "." + {"0":"9db425ba","channelStoriesPage-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage":"55507f0f","channelStoriesPage":"8da1c1d1","mobile403":"0e367aee","mobileChangePasswordPage":"62deb0c7","mobileExploreCategoryPage":"65e153bf","mobileExploreResultsPage-mobileSearchResultsPage":"762ccb75","mobileExploreResultsPage":"8402aa59","mobileSearchResultsPage":"fa68243d","mobileFavoritesPage":"ec12a381","mobileResetPasswordPage":"bac9eee5","mobileTrendingPage":"0d1e6229","vendors-gifEditPanel-gifMakerFinalize":"0691cc7a","vendors-gifEditPanel":"df4566a7","gifEditPanel":"a65dce3f","vendors-gifMakerFinalize-mobile404-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPa-9467c26e":"c577d34a","gifMakerFinalize-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage":"819c54cd","mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage":"3da86a29","mobileChannelBranchPage":"fd98a234","mobileChannelLeafPage":"98d16ef8","mobileChannelListPage":"9dc7d838","mobileChannelPage":"1f159dc5","mobile404":"f6689aa5","mobileApplyPage-mobileJoinPage-mobileLoginPage":"42ffd3f0","mobileJoinPage-mobileLoginPage":"72f24d36","mobileJoinPage":"97537ee2","mobileLoginPage":"8a0913fc","vendors-gifMakerFinalize-mobileGifMaker":"e4ff50ab","vendors-mobileApplyPage-mobileGifMaker":"8aa1064e","vendors-mobileGifMaker":"ca4b45fd","mobileGifMaker":"56d0db81","mobileApplyPage":"4385f46c","vendors-mobileDashboard":"ece50a96","mobileDashboard":"bfff7331","vendors-mobileTeamPage":"97dabd9d","mobileTeamPage":"d0cb6139","vendors-showdown":"5a93ff52","gifDetailMedia":"aac6b0a3","creationAnimate":"bebf1b2c","creationCutOut":"f74cc29c","desktopUploadFinalize":"9b618f6b","gifMakerSlideshow":"319fdf08","gifMakerVideoTrim":"25957bf3","gifMakerFinalize":"12c8faea","aboutPage":"6e39372a","appsLanding":"1e781f61","artists":"cf1a8cde","curationStation":"e13bddba","desktopChannelStories":"bc0c86a4","desktopStory":"aad80460","desktopVideoDetail":"3223a7c3","desktopVideos":"091f3e96","homebase":"c9086001","homepageBeta":"70757781"}[chunkId] + ".bundle.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/static/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
